import { create, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { Tooltip, Orientation } from '@dojo/widgets/tooltip';
import { Icon } from '../icon';
import { ActionButton } from './action-button';
const icache = createICacheMiddleware();
const factory = create({ icache, theme }).properties();
export const MenuAction = factory(({ properties, middleware: { icache } }) => {
    const { onClick, onFocus, shouldFocus = false, altText, ttText, faname, xqa, isHighlighted = false } = properties();
    const ttActive = () => {
        onFocus && onFocus();
        icache.set('ttopen', true);
    };
    const ttHidden = () => icache.set('ttopen', false);
    return w(Tooltip, { open: icache.getOrSet('ttopen', false), orientation: Orientation.bottom }, [
        {
            content: ttText,
            trigger: w(ActionButton, {
                aria: {
                    label: altText || ''
                },
                shouldFocus,
                size: 'small',
                isAction: true,
                onClick,
                onOver: ttActive,
                onOut: ttHidden,
                onFocus: ttActive,
                onBlur: ttHidden,
                isHighlighted
            }, [w(Icon, { faname, altText, xqa })])
        }
    ]);
});
